import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import queryDocument from "./getOrganizationAddressesQuery.graphql";
import type {
  HerasMemberAddressConnection,
  HerasOrganizationTypeAddressesArgs,
  Query,
  QueryOrganizationArgs,
} from "@/core/api/graphql/types";

export async function getOrganizationAddresses(
  organizationId: string,
  payload?: HerasOrganizationTypeAddressesArgs,
): Promise<HerasMemberAddressConnection> {
  const { userId } = globals;

  const { data } = await graphqlClient.query<
    Required<Pick<Query, "organization">>,
    QueryOrganizationArgs & HerasOrganizationTypeAddressesArgs
  >({
    query: queryDocument,
    variables: {
      userId,
      id: organizationId,
      ...payload,
    },
  });

  return data.organization.addresses!;
}
